import React from 'react'
import { ReactComponent as InvestmentsOutOfServiceIcon } from 'assets/svg/InvestmentsOutOfService.svg'
import { useAppSelector } from 'hooks/redux'
import { InvestmentActionType } from '../types'
import {
  AfterHoursContainer,
  ContentWrapper,
  SvgContainer,
  MessageContainer,
  MessageText,
  BoldText
} from './styles'

interface InvestmentsOutOfServiceProps {
  action: InvestmentActionType
}

const InvestmentsOutOfService: React.FC<InvestmentsOutOfServiceProps> = ({
  action
}) => {
  const { investmentHours } = useAppSelector(state => state.investments)

  const subscriptionHours = investmentHours?.subscription
  const rescueHours = investmentHours?.rescue

  const isSubscription = action === InvestmentActionType.INVEST

  return (
    <AfterHoursContainer>
      <ContentWrapper>
        <SvgContainer>
          <InvestmentsOutOfServiceIcon />
        </SvgContainer>
        <MessageContainer>
          <MessageText>
            {isSubscription
              ? 'Las suscripciones pueden realizarse de'
              : 'Los rescates pueden realizarse de'}
          </MessageText>
          <MessageText>
            <BoldText>
              Lunes a Viernes de
              {' '}
              {isSubscription
                ? subscriptionHours?.join(' a ')
                : rescueHours?.join(' a ')}
              {' '}
              hs.
            </BoldText>
          </MessageText>
          <MessageText>
            No están disponibles en feriados.
          </MessageText>
        </MessageContainer>
      </ContentWrapper>
    </AfterHoursContainer>
  )
}

export default InvestmentsOutOfService
